import { receivedDigitalApi } from '@api/index';
import { Variable, VariableRequest, VariableResponse } from '@apiContract';

export enum UserVARIABLES {
  RD_CONNECT_INSTANCE = 'RD_CONNECT_INSTANCE',
}

const userVariableApi = receivedDigitalApi.injectEndpoints({
  endpoints: (builder) => ({
    getUserVariable: builder.query<Variable, string>({
      query: (key) => `UserVariable/${key}`,
      providesTags: ['UserVariable'],
      transformResponse: (response: VariableResponse) => response.objectData,
    }),
    setUserVariable: builder.mutation<Variable, VariableRequest>({
      query: (requestData) => ({
        url: 'UserVariable',
        method: 'POST',
        body: requestData,
      }),
      invalidatesTags: ['UserVariable'],
      transformResponse: (response: VariableResponse) => response.objectData,
    }),
  }),
});

export const { useGetUserVariableQuery, useSetUserVariableMutation } = userVariableApi;
